import { render, staticRenderFns } from "./ReportsDetail.vue?vue&type=template&id=983ea876"
import script from "./ReportsDetail.vue?vue&type=script&lang=js"
export * from "./ReportsDetail.vue?vue&type=script&lang=js"
import style0 from "./ReportsDetail.vue?vue&type=style&index=0&id=983ea876&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports